<template>
  <div class="swiper-card-box">
    <div class="right-mask"></div>
    <swiper
        class="swiper"
        ref="swiper"
        :options="swiperOption"
        v-if="show"
        @resize="resizeFn"
        @slideChange="slideChange"
    >
      <swiper-slide v-for="(item, index) in list" :key="index">
        <van-image
            fit="cover"
            :src="item[imgKey]"
            :show-loading="false"
        />
        <div class="image-mask" :data-link="item[linkKey]"></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
const getStretchAndDepth = () => {
  const width = document.body.clientWidth;
  const ratio = (Math.min(width, 540) / 375);
  return {
    stretch: 71 * ratio,
    depth: 1600 * ratio,
  }
}
export default {
  name: 'swiper-card',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    imgKey: {
      type: String,
      default: 'img',
    },
    linkKey: {
      type: String,
      default: 'link',
    },
    list: {
      default: [],
    },
  },
  watch: {
    value(val) {
      // this.slideTo(val);
    },
  },
  data() {
    return {
				// 轮播
				swiperOption: {
          initialSlide: this.value,
					loop: true,
          slidesPerView: 'auto',
          centeredSlides: true,
          effect: 'coverflow',
          coverflowEffect: {
            ...getStretchAndDepth(),
            rotate: 0,
            modifier: 1,
            slideShadows : false
          },
          on: {
            click: (e) => {
              const link = e.target.dataset.link || '';
              console.log(link);
              this.$router.push(link);
            }
          }
				},
        show: true,
        isUpdateing: false,
    };
  },
  mounted() {
  },
  methods: {
    resizeFn(e) {
      if (this.isUpdateing) clearTimeout(this.isUpdateing);
      this.show = false;
      this.swiperOption.coverflowEffect = {
        ...this.swiperOption.coverflowEffect,
        ...getStretchAndDepth(),
      };
      this.$nextTick(() => {
        this.isUpdateing = setTimeout(() => this.show = true, 1000);
      })
    },

    slideChange() {
      const index = this.$refs['swiper'].$swiper.realIndex;
      this.$emit('input', index);
    },

    slideTo(index) {
      this.$refs['swiper'].$swiper.slideTo(index);
      this.$emit('input', index);
    },

    toVideoList() {
      console.log(123123123)
      this.$router.push('/video');
    },
  }
}
</script>

<style scoped>
  /*.swiper-card-box{*/
  /*  width: calc(100vw - 70px);*/
  /*  max-width: calc(540PX - 70px);*/
  /*  height: 34.8vw;*/
  /*  overflow: hidden;*/
  /*}*/
  /*.swiper-card-box .swiper{*/
  /*  position: relative;*/
  /*  left: -12.046vw;*/
  /*  width: 100vw;*/
  /*  height: 53.538vw;*/
  /*}*/
  /*.swiper-card-box .swiper .swiper-slide{*/
  /*  width: 76.292vw;*/
  /*  border-radius: 4.283vw 4.283vw 0px 0px !important;*/
  /*  overflow: hidden;*/
  /*}*/
  /*.swiper-card-box .swiper .swiper-slide .van-image{*/
  /*  width: 100%;*/
  /*  height: 40.153vw;*/
  /*  border-radius: 4.283vw 4.283vw 0px 0px !important;*/
  /*}*/
  .swiper-card-box{
    width: 305px;
    height: 125px;
    overflow: hidden;
    position: relative;
  }
  .swiper-card-box .swiper{
    position: relative;
    left: -41px;
    width: 375px;
    height: 220px;
  }
  .swiper-card-box .swiper .swiper-slide{
    width: 295px;
    border-radius: 16px 16px 0px 0px !important;
    overflow: hidden;
    position: relative;
  }
  .swiper-card-box .swiper .swiper-slide .van-image{
    width: 100%;
    height: 150px;
    border-radius: 16px 16px 0px 0px !important;
  }
  .swiper-card-box .swiper .swiper-slide .image-mask{
    width: 100%;
    height: 150px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .right-mask{
    width: 12px;
    height: 125px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 500;
  }
</style>
